
export let tableLabels = [{
  label: '视频名称',
  value: 'name'
}, {
  label: '申请人',
  value: 'applyUser.fullName'
}, {
  label: '创建时间',
  value: 'createTime_copy'
}, {
  label: '是否在工具中心展示',
  value: 'visibleInToolsCopy'
}]

export let tableLabelsOk = [...tableLabels, {
  label: '发布时间',
  value: 'publishTime_copy'
}, {
  label: '审批人',
  value: 'auditUser.fullName'
}, {
  label: '视频状态',
  value: 'status_copy'
}]
